<template lang="pug">
filter-detail-container(title="Filter Services" :save-mode="false" @back="back" @clear="clear" @save="save")
  template(v-slot:body)
    .px-6.pt-6.pb-2.text-md Choose the services(s) that you want to filter:
    .text-center.mt-8(v-if="isLoading")
      v-progress-circular(width="2" size="30" color="primary" indeterminate)
    div(v-else)
      div(v-for="service in services" :key="service.value")
        .d-flex.text-sm.pa-6.cursor-pointer.hover-bg(@click="clickItem(service.value)")
          yc-checkbox(v-model="selected" :value="service.value")
          .ml-4.font-medium {{ service.label }}
        v-divider.basic300
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  components: { FilterDetailContainer },
  data: () => ({
    isLoading: true,
    selected: [],
    services: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  created () {
    this.fetchServices()
    if (this.filter.items) {
      this.selected = this.filter.items
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchServices () {
      this.isLoading = true
      this.$axios.get(`/clinics/${this.company.slug}/services?fields=id,name&page_size=-1`)
      .then(resp => {
        this.services = resp.data.results.map(item => {
          return {
            label: item.name,
            value: `${item.id}`
          }
        })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    save () {
      const filter = {}
      if (this.selected.length) {
        filter['items'] = this.selected
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back () {
      this.$emit('onBack')
    },
    clear () {
      this.selected = []
    },
    clickItem (value) {
      if (this.selected.includes(value)) {
        this.selected = this.selected.filter(x => x !== value)
      } else {
        this.selected.push(value)
      }
    }
  }
}
</script>